/* tslint:disable */
/* eslint-disable */
export enum UserVerificationProvider {
  InHouse = 'in_house',
  External = 'external'
}
